import React from 'react';
import {SurveyProvider, } from "../../context/SurveyContext";
import PassengerForm from "../../components/passengerInformation/PassengerForm";



function PassengerFormPage(props) {
    return (
        <SurveyProvider>
            <PassengerForm {...props} />
        </SurveyProvider>
    )

}

export default PassengerFormPage;

